import axios from 'axios';

export default {
  namespaced: true,
  state: {
    error: null,
    loading: false,
    data: [],
    fieldsMapsTotal: 0,
    successSaved: false,
  },
  mutations: {
    setError(state, error) {
      state.error = error;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setData(state, data) {
      state.data = data;
    },
    setFieldsMapsTotal(state, total) {
      state.fieldsMapsTotal = total;
    },
    setSuccessSaved(state, success) {
      state.successSaved = success;
    },
    clearMessages(state) {
      state.loading = false;
      state.error = null;
      state.successSaved = false;
    },
  },
  actions: {
    async saveFieldsMaps({ commit }, payload) {
      commit('setLoading', true);
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/import/fields-map`,
          payload,
        );
        commit('setSuccessSaved', true);
      } catch (error) {
        if (error && error.data && error.data.error) {
          commit('setError', error.data.error);
        } else {
          commit('setError', error);
        }
      }
      commit('setLoading', false);
    },
    async findFieldsMaps({ commit }, querySettings) {
      commit('setLoading', true);
      const { page, limit, search } = querySettings;

      const skip = limit * (page - 1);
      const params = {
        $skip: skip,
        $limit: limit,
      };

      if (search) {
        params['$search'] = search;
      }

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/import/fields-map`,
          { params },
        );
        commit('setData', response.data.data);
        commit('setFieldsMapsTotal', response.data.total);
      } catch (error) {
        if (error && error.data && error.data.error) {
          commit('setError', error.data.error);
        } else {
          commit('setError', error);
        }
      }
      commit('setLoading', false);
    },
  },
};
